import { useEffect, useState } from "react";
import { msmartAxios } from "../../../api/axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { getErrorMessage, isCanceled } from "../../../utils/errorMessage";

// Checks the signed-in user belongs to :teamId before an M-SMART page renders its data.
// view: null while checking, then true/false. error: set when the check itself failed.
export default function useTeamAccess(teamId) {
  const { user } = useAuthContext();
  const [view, setView] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user?.token) return;
    const controller = new AbortController();
    setView(null);
    setError("");

    msmartAxios
      .get("/api/msmart/get/user/team", {
        headers: { accessToken: user.token },
        signal: controller.signal,
      })
      .then((res) => {
        setView(res.status === 201 && String(res.data?.teamId) === String(teamId));
      })
      .catch((err) => {
        if (isCanceled(err)) return;
        setError(getErrorMessage(err, "Unable to verify your access to this team."));
      });

    return () => controller.abort();
  }, [user?.token, teamId]);

  return { view, error };
}
